import { Component, Host, h, Prop, getAssetPath, EventEmitter, Event, State, Listen } from '@stencil/core';
import utils from '../../utils/utils';
import { getAuthState, User } from '../sy-site-auth/store/store';
import { getLanguagePath } from '../sy-site-i18n/static-i18n';
import { Consumes } from '@sydle/sydle-ui';
@Component({
  tag: 'sy-site-header',
  styleUrl: './scss/index.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class SydleSiteHeader {
  @Consumes('i18next:instance') @State() siteI18n!: HTMLSySiteI18nElement;
  @Consumes('siteAuth') @State() siteAuth!: HTMLSySiteAuthElement;
  @Consumes('i18next:language') @State() lang: string;
  @Consumes('hideUserTab') @State() hideUserTab: boolean;

  private ctaButton;
  private user;

  @State() logoHref = '/';

  @State() searchHref = `/blog/search`;

  /**
   * Event emitted on nav button click
   */
  @Event() sySiteHeaderNavigate: EventEmitter;

  /**
   * Event emitted on logout
   */
  @Event() sySiteHeaderDidLogout: EventEmitter<User>;

  /**
   * Event emitted on site cta click
   */
  @Event() syCtaDidClick: EventEmitter;

  /**
   * Text used for logout button
   */
  @Prop() logoutText = 'Sair';

  /**
   * Enable to use backlink
   */
  @Prop() backLink = false;

  /**
   * Link that backLink leads to
   */
  @Prop() backLinkHref = '/';

  /**
   * Title of cta header
   */
  @Prop() ctaTitle;

  /**
   * Icon of cta header
   */
  @Prop() ctaIcon;

  /**
   * Link that CTA leads to
   */
  @Prop() ctaHref;

  /**
   * Enable to use blog search button
   */
  @Prop() searchButton = false;

  @Listen('sySiteLoginDidClose', { target: 'body' })
  @Listen('sySiteAlertModalDidClose', { target: 'body' })
  @Listen('syBlogLoginDidClose', { target: 'body' })
  @Listen('syBlogAlertModalDidClose', { target: 'body' })
  enableNewsletterButton(): void {
    this.ctaButton.disabled = false;
    this.ctaButton.loading = false;
  }

  @Listen('sySiteLogoutDropdownContentDidLogout')
  logout() {
    this.sySiteHeaderDidLogout.emit(this.user);
    this.siteAuth.logout();
  }

  componentWillRender() {
    this.logoHref = window.location.origin + getLanguagePath(this.lang);
    this.searchHref = `${getLanguagePath(this.lang)}/blog/search`;
  }

  private handleCtaClick(_event: Event) {
    if (this.ctaHref) {
      window.location.assign(this.ctaHref);
    }
    this.ctaButton.disabled = true;
    this.ctaButton.loading = true;
    this.syCtaDidClick.emit();
  }

  render() {
    this.user = getAuthState('user');
    return (
      <Host>
        <div id="fixed-navbar" data-sy-viewport>
          <div class="nav-button block">
            {this.backLink ? (
              <a href={this.backLinkHref} aria-label="Voltar">
                <sy-icon name="arrow-left" path="assets/icons" family="streamline-light" role="img" aria-label="arrow left"></sy-icon>
                <sy-text>Voltar</sy-text>
              </a>
            ) : (
              <sy-site-burger-icon></sy-site-burger-icon>
            )}
          </div>

          <div class="logo block">
            <img src={getAssetPath('./assets/sydle-logo-white.svg')} onClick={() => window.location.assign(this.logoHref)} />
          </div>

          <div class="user-toolbar block">
            {this.ctaTitle && (this.user ? this.ctaTitle.toLowerCase() != 'login' : true) && (
              <sy-button
                ref={(el: HTMLSyButtonElement) => {
                  this.ctaButton = el;
                }}
                onClick={e => this.handleCtaClick(e)}
                icon={this.ctaIcon}
                content="icon-right"
                target="_self"
              >
                {this.ctaTitle}
              </sy-button>
            )}

            {this.user && !this.hideUserTab
              ? [
                <sy-avatar
                  small
                  rounded
                  class="user-avatar"
                  image={this.user.photo?._id ? utils.getImageUrl(this.user._class._id, this.user.code, this.user.photo._id) : undefined}
                  key="avatar"
                  initials={this.user.name.toUpperCase()[0]}
                  initialsSize={1}
                ></sy-avatar>,
                <sy-dropdown toggle-by=".user-avatar" placement="bottom-end" container=".user-avatar" key="dropdown">
                  <sy-site-logout-dropdown-content logoutText={this.logoutText}></sy-site-logout-dropdown-content>
                </sy-dropdown>,
              ]
              : null}
            {this.searchButton ? (
              <a href={this.searchHref}>
                <sy-icon class="search-icon" name="search" size="24"></sy-icon>
              </a>
            ) : null}
          </div>
        </div>
      </Host>
    );
  }
}
